jQuery(document).ready(function(jQuery) {            
  var sidebarLinks = jQuery(".sidebarLinks"),
  offset = 40,
  topMenuHeight = sidebarLinks.outerHeight()+offset,
  // All list items
  menuItems =  sidebarLinks.find('a[href*="#"]'),
  // Anchors corresponding to menu items
  scrollItems = menuItems.map(function(){
    var href = jQuery(this).attr("href"),
        id = href.substring(href.indexOf('#')),
        item = jQuery(id);
    //console.log(item)
    if (item.length) { return item; }
  });

  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = jQuery(this).attr("href"),
        id = href.substring(href.indexOf('#'));
    offsetTop = href === "#" ? 0 : jQuery(id).offset().top-topMenuHeight+1;
    jQuery('html, body').stop().animate({ 
      scrollTop: offsetTop
    }, 300);
    e.preventDefault();
  });

  // Bind to scroll
  jQuery(window).scroll(function(){
    // Get container scroll position
    var fromTop = (jQuery(this).scrollTop()+topMenuHeight)+100;

    // Get id of current scroll item
    var cur = scrollItems.map(function(){
      if (jQuery(this).offset().top < fromTop)
        return this;
    });

    // Get the id of the current element
    cur = cur[cur.length-1];
    var id = cur && cur.length ? cur[0].id : "";               

    menuItems.parent().removeClass("active");
    if(id){
      menuItems.parent().end().filter("[href*='#"+id+"']").parent().addClass("active");
    }

})
  
// Custom accordion
$(function() {
  $('.acc__title').click(function(j) {

    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }

    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});

// Custom tab
$('body').on('click', '.nav-tabs .nav-item .nav-link', function(){
    $('.nav-tabs .nav-link.active').removeClass('active');
    $(this).addClass('active');
    var target = $(this).attr('data-bs-target');
    $('.tab-content .tab-pane.active').removeClass('active').removeClass('show');
    $('.tab-content .tab-pane'+target).addClass('active').addClass('show');
});

  
})

// Slick slider / Products / Height Adjustable Desk page
$('.had-products').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  autoplay: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// Slick slider / Products / Height Adjustable Desk page
$('.five-icon-slider').slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// Slick slider / Products / Height Adjustable Desk page
$('.three-icon-slider').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

setTimeout(function(){
  $('.product-external-box').matchHeight({
    byRow: true,
  });
  $('.product-external-box ul').matchHeight({
    byRow: true,
  });
},3000);

if(document.querySelector(".live-search")) {
    jQuery('.search-icon-responsive').on('click', function(event) {
        jQuery('.live-search').toggleClass('active');
    });
}

jQuery('.sticky-menu .sticky-menu-inner ul li.has-submenu').on('click', function(event) {
  jQuery('.sticky-menu .submenu').toggleClass('open');
});

jQuery('.main-banner').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  autoplay: true
});

// Custom tabs
$(document).ready(function(){ 
  $('.tab-a').click(function(){  
    $(".tab").removeClass('tab-active');
    $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
    $(".tab-a").removeClass('active-a');
    $(this).parent().find(".tab-a").addClass('active-a');
  });
});

$('.first-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  autoplay: true,
  appendArrows: jQuery(".first-slider-btn"),
  prevArrow: '<button class="slider-arrow prev-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/prev-arrow.png?v=1644416775"></button>',
  nextArrow: '<button class="slider-arrow next-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/next-arrow.png?v=1644416790"></button>'
});

$('.second-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  autoplay: true,
  appendArrows: jQuery(".second-slider-btn"),
  prevArrow: '<button class="slider-arrow prev-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/prev-arrow.png?v=1644416775"></button>',
  nextArrow: '<button class="slider-arrow next-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/next-arrow.png?v=1644416790"></button>'
});

$('.third-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  autoplay: true,
  appendArrows: jQuery(".third-slider-btn"),
  prevArrow: '<button class="slider-arrow prev-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/prev-arrow.png?v=1644416775"></button>',
  nextArrow: '<button class="slider-arrow next-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/next-arrow.png?v=1644416790"></button>'
});

if(document.querySelector(".products-list")) {
  $('.products-list').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    appendArrows: jQuery(".products-slider-btn"),
    prevArrow: '<button class="slider-arrow prev-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/prev-arrow.png?v=1644416775"></button>',
    nextArrow: '<button class="slider-arrow next-btn"><img src="https://cdn.shopify.com/s/files/1/0560/9517/8944/files/next-arrow.png?v=1644416790"></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}

/* $('.products-list-item-desc h3').matchHeight({
  byRow: true,
}); */

$('.collection-custom-tab .tab-wrap').matchHeight({
  byRow: true,
});

if(document.querySelector(".studio-page")) {
  $('.studio-page-banner').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true
  });
}


if(document.querySelector(".featured-collections")) {
  $('.featured-collections-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}

// new added
if(document.querySelector(".slider")) {
$('.slider').slick({
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button class="slider-arrow prev-btn prew-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
  nextArrow: '<button class="slider-arrow next-btn next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
     }
   },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
       slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
       slidesToShow: 1,
        slidesToScroll: 1
     }
    }
  ]
});

} 
  


//created by web developer

/* Swatches Hover box code start */


$(document).ready(function(){
  
  $("#static-variant-option-0-0").mouseover(function(){

    $('#variant-option-0-0').show();
  });
  $("#static-variant-option-0-0").mouseout(function(){
    $('#variant-option-0-0').hide();
  });

  $("#static-variant-option-0-1").mouseover(function(){

    $('#variant-option-0-1').show();
  });
  $("#static-variant-option-0-1").mouseout(function(){
    $('#variant-option-0-1').hide();
  });

  $("#static-variant-option-0-2").mouseover(function(){

    $('#variant-option-0-2').show();
  });
  $("#static-variant-option-0-2").mouseout(function(){
    $('#variant-option-0-2').hide();
  });

  $("#static-variant-option-0-3").mouseover(function(){

    $('#variant-option-0-3').show();
  });
  $("#static-variant-option-0-3").mouseout(function(){
    $('#variant-option-0-3').hide();
  });

 $("#static-variant-option-0-4").mouseover(function(){

    $('#variant-option-0-4').show();
  });
  $("#static-variant-option-0-4").mouseout(function(){
    $('#variant-option-0-4').hide();
  });

 $("#static-variant-option-0-5").mouseover(function(){

    $('#variant-option-0-5').show();
  });
  $("#static-variant-option-0-5").mouseout(function(){
    $('#variant-option-0-5').hide();
  });

});

/* Swatches Hover box code end */
